<template>
  <div class="loading-spinner" ref="loadingSpinner">
    <div class="title">
      <h1>{{ lang('loading') }}</h1>
    </div>
    <div class="icon">
      <svg version="1.1" id="L1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
          <circle fill="none" stroke="#fff" stroke-width="6" stroke-miterlimit="15" stroke-dasharray="14.2472,14.2472" cx="50" cy="50" r="47" >
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="5s"
              from="0 50 50"
              to="360 50 50"
              repeatCount="indefinite" />
        </circle>
        <circle fill="none" stroke="#fff" stroke-width="1" stroke-miterlimit="10" stroke-dasharray="10,10" cx="50" cy="50" r="39">
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="5s"
              from="0 50 50"
              to="-360 50 50"
              repeatCount="indefinite" />
        </circle>
        <g fill="#fff">
        <rect x="30" y="35" width="5" height="30">
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5 ; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.1"/>
        </rect>
        <rect x="40" y="35" width="5" height="30" >
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5 ; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.2"/>
        </rect>
        <rect x="50" y="35" width="5" height="30" >
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5 ; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.3"/>
        </rect>
        <rect x="60" y="35" width="5" height="30" >
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5 ; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.4"/>
        </rect>
        <rect x="70" y="35" width="5" height="30" >
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5 ; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.5"/>
        </rect>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  inject: ['lang'],
  mounted() {
    setTimeout(() => {
      this.$refs.loadingSpinner.style.opacity = 0;
    }, 2000);
  }
}
</script>

<style lang="scss" scoped>
.loading-spinner {
  background: #000 url('/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/01_IntroBackground.png') no-repeat fixed center;
  background-size: cover;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100000;
  opacity: 1;
  pointer-events: none;
  transition: 1s;

  h1 {
    color: #fff;
    font-family: 'american-typewriter', 'Courier New', Courier, monospace;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
    letter-spacing: 6px;
    font-weight: bold;
    font-size: 4vw;
    transition: 0.2s;
    animation: glowing 1s infinite alternate;
  }
  .icon {
    max-width: 20%;
    margin: 0 auto;
    transform: translateX(-63%) translateY(-50%);
    top: 50%;
    position: absolute;
    width: 20%;
    left: 50%;
  }
}
@keyframes glowing {
  0% {
      text-shadow: 0 0 5px #fff;
  }
  100% {
      text-shadow: 0 0 10px #fff;
  }
}

</style>
